/* eslint-disable */ import { AjvReflection, DomainEntityReflection, EnumReflection, RawAliasReflection } from '@salsita-ai/platform-project-sdk/domain';
export const modelVersion = 3;
export const Finish = new EnumReflection('Finish', {
    enum: [
        'brushed',
        'milled',
        'chequer',
        'propeller'
    ]
});
export const FinishDirection = new EnumReflection('FinishDirection', {
    enum: [
        'horizontal',
        'vertical'
    ]
});
export const Handing = new EnumReflection('Handing', {
    enum: [
        'standard',
        'reverse'
    ]
});
export const RawMaterial = new EnumReflection('RawMaterial', {
    enum: [
        'brass',
        'ss304',
        'ss316',
        'aluminium'
    ]
});
export const AttributeOption = new AjvReflection('AttributeOption', {
    type: 'object',
    properties: {
        label: {
            type: 'string'
        },
        value: {
            type: [
                'string',
                'number'
            ]
        }
    },
    required: [
        'label',
        'value'
    ],
    additionalProperties: false
});
export const Point = new AjvReflection('Point', {
    type: 'object',
    properties: {
        x: {
            type: 'number'
        },
        y: {
            type: 'number'
        }
    },
    required: [
        'x',
        'y'
    ],
    additionalProperties: false
});
export const Size = new AjvReflection('Size', {
    type: 'object',
    properties: {
        x: {
            type: 'number'
        },
        y: {
            type: 'number'
        }
    },
    required: [
        'x',
        'y'
    ],
    additionalProperties: false
});
export const Geometry = new AjvReflection('Geometry', {
    type: 'array',
    items: {
        type: 'array',
        items: {
            type: 'array',
            items: {
                type: 'array',
                items: {
                    type: 'number'
                }
            }
        }
    }
});
export const AnchorPointPosition = new EnumReflection('AnchorPointPosition', {
    enum: [
        'topLeft',
        'topRight',
        'bottomLeft',
        'bottomRight',
        'top',
        'bottom',
        'left',
        'right',
        'center'
    ]
});
export const CustomMaterial = new AjvReflection('CustomMaterial', {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        name: {
            type: 'string'
        },
        code: {
            type: 'string'
        },
        length: {
            type: 'number'
        },
        width: {
            type: 'number'
        },
        thickness: {
            type: 'number'
        },
        rawMaterial: RawMaterial._meta.schema,
        finish: Finish._meta.schema,
        standard: {
            type: 'boolean'
        }
    },
    required: [
        'id',
        'name',
        'code',
        'length',
        'width',
        'thickness',
        'rawMaterial',
        'finish',
        'standard'
    ],
    additionalProperties: false
});
export const Countersink = new AjvReflection('Countersink', {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        topRadius: {
            type: 'number'
        },
        bottomRadius: {
            type: 'number'
        },
        plateThicknessMin: {
            type: 'number'
        },
        plateThicknessMax: {
            type: 'number'
        }
    },
    required: [
        'id',
        'topRadius',
        'bottomRadius',
        'plateThicknessMin',
        'plateThicknessMax'
    ],
    additionalProperties: false
});
export const FeatureSetting = new AjvReflection('FeatureSetting', {
    type: 'object',
    properties: {
        plateType: {
            type: 'string'
        },
        featureType: {
            type: 'string'
        },
        offsetX: {
            type: 'number'
        },
        offsetY: {
            type: 'number'
        },
        anchorPointPosition: AnchorPointPosition._meta.schema
    },
    required: [
        'plateType',
        'featureType',
        'offsetX',
        'offsetY',
        'anchorPointPosition'
    ],
    additionalProperties: false
});
const KickPlateShape = new AjvReflection('KickPlateShape', {
    type: 'object',
    properties: {
        cornerRadius: {
            type: 'number'
        },
        horizontalLength: {
            type: 'number'
        },
        verticalLength: {
            type: 'number'
        }
    },
    additionalProperties: false,
    required: [
        'cornerRadius',
        'horizontalLength',
        'verticalLength'
    ]
});
const RectangularPlateShape = new AjvReflection('RectangularPlateShape', {
    type: 'object',
    properties: {
        cornerRadius: {
            type: 'number'
        },
        horizontalLength: {
            type: 'number'
        },
        verticalLength: {
            type: 'number'
        }
    },
    additionalProperties: false,
    required: [
        'cornerRadius',
        'horizontalLength',
        'verticalLength'
    ]
});
const SquarePlateShape = new AjvReflection('SquarePlateShape', {
    type: 'object',
    properties: {
        cornerRadius: {
            type: 'number'
        },
        sideLength: {
            type: 'number'
        }
    },
    additionalProperties: false,
    required: [
        'cornerRadius',
        'sideLength'
    ]
});
const RoundPlateShape = new AjvReflection('RoundPlateShape', {
    type: 'object',
    properties: {
        diameter: {
            type: 'number'
        }
    },
    additionalProperties: false,
    required: [
        'diameter'
    ]
});
const PlateShape = new AjvReflection('PlateShape', {
    type: 'object',
    properties: {
        finishDirection: FinishDirection._meta.schema,
        quantity: {
            type: 'integer',
            minimum: 1
        },
        handing: Handing._meta.schema,
        powderCoating: {
            type: 'boolean'
        },
        thickness: {
            type: 'number'
        },
        rawMaterial: RawMaterial._meta.schema,
        finish: Finish._meta.schema,
        usage: {
            type: 'string'
        }
    },
    additionalProperties: false,
    required: [
        'finishDirection',
        'quantity',
        'handing',
        'powderCoating',
        'thickness',
        'rawMaterial',
        'finish',
        'usage'
    ]
});
const AnyBoltHoleShape = new AjvReflection('AnyBoltHoleShape', {
    type: 'object',
    properties: {
        radius: {
            type: 'number'
        }
    },
    additionalProperties: false,
    required: [
        'radius'
    ]
});
const AnyCountersinkHoleShape = new AjvReflection('AnyCountersinkHoleShape', {
    type: 'object',
    properties: {
        topRadius: {
            type: 'number'
        },
        bottomRadius: {
            type: 'number'
        },
        countersinkId: {
            type: 'string'
        }
    },
    additionalProperties: false,
    required: [
        'topRadius',
        'bottomRadius',
        'countersinkId'
    ]
});
const KickPlateFixingHolesShape = new AjvReflection('KickPlateFixingHolesShape', {
    type: 'object',
    properties: {
        count: {
            type: 'integer',
            multipleOf: 2
        }
    },
    additionalProperties: false,
    required: [
        'count'
    ]
});
const PlainCylinderHoleShape = new AjvReflection('PlainCylinderHoleShape', {
    type: 'object',
    properties: {
        radius: {
            type: 'number'
        }
    },
    additionalProperties: false,
    required: [
        'radius'
    ]
});
const PlainLocksetHoleShape = new AjvReflection('PlainLocksetHoleShape', {
    type: 'object',
    properties: {
        radius: {
            type: 'number'
        }
    },
    additionalProperties: false,
    required: [
        'radius'
    ]
});
const Hole54Shape = new AjvReflection('Hole54Shape', {
    type: 'object',
    properties: {
        radius: {
            type: 'number',
            enum: [
                27
            ]
        }
    },
    additionalProperties: false,
    required: [
        'radius'
    ]
});
const RimCylinderHoleShape = new AjvReflection('RimCylinderHoleShape', {
    type: 'object',
    properties: {
        radius: {
            type: 'number',
            enum: [
                15.25
            ]
        }
    },
    additionalProperties: false,
    required: [
        'radius'
    ]
});
const DeadboltHoleShape = new AjvReflection('DeadboltHoleShape', {
    type: 'object',
    properties: {
        radius: {
            type: 'number',
            enum: [
                27
            ]
        }
    },
    additionalProperties: false,
    required: [
        'radius'
    ]
});
const CamlockHoleShape = new AjvReflection('CamlockHoleShape', {
    type: 'object',
    properties: {
        width: {
            type: 'number',
            enum: [
                16.5
            ]
        },
        height: {
            type: 'number',
            enum: [
                19.4
            ]
        }
    },
    additionalProperties: false,
    required: [
        'width',
        'height'
    ]
});
const EuroCylinderHoleShape = new AjvReflection('EuroCylinderHoleShape', {
    type: 'object',
    properties: {
        topWidth: {
            type: 'number',
            enum: [
                10.7
            ]
        },
        bottomWidth: {
            type: 'number',
            enum: [
                17.75
            ]
        },
        height: {
            type: 'number',
            enum: [
                33.6
            ]
        }
    },
    additionalProperties: false,
    required: [
        'topWidth',
        'bottomWidth',
        'height'
    ]
});
const OvalCylinderHoleShape = new AjvReflection('OvalCylinderHoleShape', {
    type: 'object',
    properties: {
        width: {
            type: 'number',
            enum: [
                19
            ]
        },
        height: {
            type: 'number',
            enum: [
                33
            ]
        }
    },
    additionalProperties: false,
    required: [
        'width',
        'height'
    ]
});
const PN6HoleShape = new AjvReflection('PN6HoleShape', {
    type: 'object',
    properties: {
        width: {
            type: 'number',
            enum: [
                69
            ]
        },
        height: {
            type: 'number',
            enum: [
                55
            ]
        },
        joinRadius: {
            type: 'number',
            enum: [
                7
            ]
        },
        sideRadius: {
            type: 'number',
            enum: [
                3.25
            ]
        }
    },
    additionalProperties: false,
    required: [
        'width',
        'height',
        'joinRadius',
        'sideRadius'
    ]
});
const PD7HoleShape = new AjvReflection('PD7HoleShape', {
    type: 'object',
    properties: {
        primaryRadius: {
            type: 'number',
            enum: [
                27
            ]
        },
        verticalCenterDistance: {
            type: 'number',
            enum: [
                34.65
            ]
        },
        verticalRadius: {
            type: 'number',
            enum: [
                3.5
            ]
        },
        diagonalCenterDistance: {
            type: 'number',
            enum: [
                33
            ]
        },
        diagonalRadius: {
            type: 'number',
            enum: [
                3
            ]
        },
        horizontalCenterDistance: {
            type: 'number',
            enum: [
                29
            ]
        },
        horizontalRadius: {
            type: 'number',
            enum: [
                2.5
            ]
        }
    },
    additionalProperties: false,
    required: [
        'primaryRadius',
        'verticalCenterDistance',
        'verticalRadius',
        'diagonalCenterDistance',
        'diagonalRadius',
        'horizontalCenterDistance',
        'horizontalRadius'
    ]
});
const RectangularHoleShape = new AjvReflection('RectangularHoleShape', {
    type: 'object',
    properties: {
        cornerRadius: {
            type: 'number'
        },
        width: {
            type: 'number'
        },
        height: {
            type: 'number'
        }
    },
    additionalProperties: false,
    required: [
        'cornerRadius',
        'width',
        'height'
    ]
});
const SquareHoleShape = new AjvReflection('SquareHoleShape', {
    type: 'object',
    properties: {
        cornerRadius: {
            type: 'number'
        },
        sideLength: {
            type: 'number'
        }
    },
    additionalProperties: false,
    required: [
        'cornerRadius',
        'sideLength'
    ]
});
const FeatureShape = new AjvReflection('FeatureShape', {
    type: 'object',
    properties: {
        x: {
            type: 'number'
        },
        y: {
            type: 'number'
        },
        anchorPointFromId: {
            type: 'string',
            pattern: '^[A-Z]\\w*-\\d+$'
        },
        anchorPointToId: {
            type: 'string',
            pattern: '^[A-Z]\\w*-\\d+$'
        }
    },
    additionalProperties: false,
    required: [
        'x',
        'y',
        'anchorPointFromId',
        'anchorPointToId'
    ]
});
const AnchorPointShape = new AjvReflection('AnchorPointShape', {
    type: 'object',
    properties: {
        shapeId: {
            type: 'string',
            pattern: '^[A-Z]\\w*-\\d+$'
        },
        position: AnchorPointPosition._meta.schema
    },
    additionalProperties: false,
    required: [
        'shapeId',
        'position'
    ]
});
export const KickPlate = new DomainEntityReflection('KickPlate', [
    KickPlateShape._meta.schema,
    PlateShape._meta.schema
]);
export const RectangularPlate = new DomainEntityReflection('RectangularPlate', [
    RectangularPlateShape._meta.schema,
    PlateShape._meta.schema
]);
export const RoundPlate = new DomainEntityReflection('RoundPlate', [
    RoundPlateShape._meta.schema,
    PlateShape._meta.schema
]);
export const SquarePlate = new DomainEntityReflection('SquarePlate', [
    SquarePlateShape._meta.schema,
    PlateShape._meta.schema
]);
export const BoltHole = new DomainEntityReflection('BoltHole', [
    AnyBoltHoleShape._meta.schema,
    FeatureShape._meta.schema
]);
export const PlainCylinderHole = new DomainEntityReflection('PlainCylinderHole', [
    PlainCylinderHoleShape._meta.schema,
    FeatureShape._meta.schema
]);
export const RimCylinderHole = new DomainEntityReflection('RimCylinderHole', [
    RimCylinderHoleShape._meta.schema,
    FeatureShape._meta.schema
]);
export const Hole54 = new DomainEntityReflection('Hole54', [
    Hole54Shape._meta.schema,
    FeatureShape._meta.schema
]);
export const DeadboltHole = new DomainEntityReflection('DeadboltHole', [
    DeadboltHoleShape._meta.schema,
    FeatureShape._meta.schema
]);
export const PlainLocksetHole = new DomainEntityReflection('PlainLocksetHole', [
    PlainLocksetHoleShape._meta.schema,
    FeatureShape._meta.schema
]);
export const CornerBoltHoles = new DomainEntityReflection('CornerBoltHoles', [
    AnyBoltHoleShape._meta.schema,
    FeatureShape._meta.schema
]);
export const CornerCountersinkHoles = new DomainEntityReflection('CornerCountersinkHoles', [
    AnyCountersinkHoleShape._meta.schema,
    FeatureShape._meta.schema
]);
export const KickPlateBoltHoles = new DomainEntityReflection('KickPlateBoltHoles', [
    AnyBoltHoleShape._meta.schema,
    KickPlateFixingHolesShape._meta.schema,
    FeatureShape._meta.schema
]);
export const KickPlateCountersinkHoles = new DomainEntityReflection('KickPlateCountersinkHoles', [
    AnyCountersinkHoleShape._meta.schema,
    KickPlateFixingHolesShape._meta.schema,
    FeatureShape._meta.schema
]);
export const CountersinkHole = new DomainEntityReflection('CountersinkHole', [
    AnyCountersinkHoleShape._meta.schema,
    FeatureShape._meta.schema
]);
export const CamlockHole = new DomainEntityReflection('CamlockHole', [
    CamlockHoleShape._meta.schema,
    FeatureShape._meta.schema
]);
export const EuroCylinderHoleAu = new DomainEntityReflection('EuroCylinderHoleAu', [
    EuroCylinderHoleShape._meta.schema,
    FeatureShape._meta.schema
]);
export const EuroCylinderHoleEu = new DomainEntityReflection('EuroCylinderHoleEu', [
    EuroCylinderHoleShape._meta.schema,
    FeatureShape._meta.schema
]);
export const OvalCylinderHole = new DomainEntityReflection('OvalCylinderHole', [
    OvalCylinderHoleShape._meta.schema,
    FeatureShape._meta.schema
]);
export const PN6Hole = new DomainEntityReflection('PN6Hole', [
    PN6HoleShape._meta.schema,
    FeatureShape._meta.schema
]);
export const PD7Hole = new DomainEntityReflection('PD7Hole', [
    PD7HoleShape._meta.schema,
    FeatureShape._meta.schema
]);
export const RectangularHole = new DomainEntityReflection('RectangularHole', [
    RectangularHoleShape._meta.schema,
    FeatureShape._meta.schema
]);
export const SquareHole = new DomainEntityReflection('SquareHole', [
    SquareHoleShape._meta.schema,
    FeatureShape._meta.schema
]);
export const AnchorPoint = new DomainEntityReflection('AnchorPoint', [
    AnchorPointShape._meta.schema
]);
export const AnyDomainEntity = new RawAliasReflection('AnyDomainEntity', [
    KickPlate,
    RectangularPlate,
    RoundPlate,
    SquarePlate,
    BoltHole,
    PlainCylinderHole,
    RimCylinderHole,
    Hole54,
    DeadboltHole,
    PlainLocksetHole,
    CornerBoltHoles,
    CornerCountersinkHoles,
    KickPlateBoltHoles,
    KickPlateCountersinkHoles,
    CountersinkHole,
    CamlockHole,
    EuroCylinderHoleAu,
    EuroCylinderHoleEu,
    OvalCylinderHole,
    PN6Hole,
    PD7Hole,
    RectangularHole,
    SquareHole,
    AnchorPoint
]);
export const Plate = new RawAliasReflection('Plate', [
    KickPlate,
    RectangularPlate,
    RoundPlate,
    SquarePlate
]);
export const RootEntity = new RawAliasReflection('RootEntity', [
    ...Plate.reflections
]);
export const FixingHole = new RawAliasReflection('FixingHole', [
    CornerBoltHoles,
    BoltHole,
    CountersinkHole,
    CornerCountersinkHoles,
    KickPlateBoltHoles,
    KickPlateCountersinkHoles
]);
export const AnyBoltHole = new RawAliasReflection('AnyBoltHole', [
    CornerBoltHoles,
    BoltHole,
    KickPlateBoltHoles
]);
export const AnyCountersinkHole = new RawAliasReflection('AnyCountersinkHole', [
    CountersinkHole,
    CornerCountersinkHoles,
    KickPlateCountersinkHoles
]);
export const SingleFixingHole = new RawAliasReflection('SingleFixingHole', [
    BoltHole,
    CountersinkHole
]);
export const CornerFixingHoles = new RawAliasReflection('CornerFixingHoles', [
    CornerBoltHoles,
    CornerCountersinkHoles
]);
export const KickPlateFixingHoles = new RawAliasReflection('KickPlateFixingHoles', [
    KickPlateBoltHoles,
    KickPlateCountersinkHoles
]);
export const CircularFeature = new RawAliasReflection('CircularFeature', [
    CornerBoltHoles,
    BoltHole,
    KickPlateBoltHoles,
    PlainCylinderHole,
    RimCylinderHole,
    Hole54,
    DeadboltHole,
    PlainLocksetHole
]);
export const EuroCylinderHole = new RawAliasReflection('EuroCylinderHole', [
    EuroCylinderHoleEu,
    EuroCylinderHoleAu
]);
export const CylinderHole = new RawAliasReflection('CylinderHole', [
    OvalCylinderHole,
    RimCylinderHole,
    EuroCylinderHoleAu,
    EuroCylinderHoleEu,
    CamlockHole,
    PlainCylinderHole
]);
export const LocksetHole = new RawAliasReflection('LocksetHole', [
    Hole54,
    PD7Hole,
    PN6Hole,
    DeadboltHole,
    PlainLocksetHole
]);
export const ShapeHole = new RawAliasReflection('ShapeHole', [
    RectangularHole,
    SquareHole
]);
export const Feature = new RawAliasReflection('Feature', [
    CountersinkHole,
    CornerCountersinkHoles,
    KickPlateCountersinkHoles,
    CornerBoltHoles,
    BoltHole,
    KickPlateBoltHoles,
    PlainCylinderHole,
    RimCylinderHole,
    Hole54,
    DeadboltHole,
    PlainLocksetHole,
    CamlockHole,
    EuroCylinderHoleEu,
    EuroCylinderHoleAu,
    OvalCylinderHole,
    PN6Hole,
    PD7Hole,
    RectangularHole,
    SquareHole
]);
export const AnchorableShape = new RawAliasReflection('AnchorableShape', [
    ...Plate.reflections,
    ...Feature.reflections
]);
export const aliases = {
    AnyDomainEntity: AnyDomainEntity.types,
    Plate: Plate.types,
    RootEntity: RootEntity.types,
    FixingHole: FixingHole.types,
    AnyBoltHole: AnyBoltHole.types,
    AnyCountersinkHole: AnyCountersinkHole.types,
    SingleFixingHole: SingleFixingHole.types,
    CornerFixingHoles: CornerFixingHoles.types,
    KickPlateFixingHoles: KickPlateFixingHoles.types,
    CircularFeature: CircularFeature.types,
    EuroCylinderHole: EuroCylinderHole.types,
    CylinderHole: CylinderHole.types,
    LocksetHole: LocksetHole.types,
    ShapeHole: ShapeHole.types,
    Feature: Feature.types,
    AnchorableShape: AnchorableShape.types
};
export const entities = {
    KickPlate,
    RectangularPlate,
    RoundPlate,
    SquarePlate,
    BoltHole,
    PlainCylinderHole,
    RimCylinderHole,
    Hole54,
    DeadboltHole,
    PlainLocksetHole,
    CornerBoltHoles,
    CornerCountersinkHoles,
    KickPlateBoltHoles,
    KickPlateCountersinkHoles,
    CountersinkHole,
    CamlockHole,
    EuroCylinderHoleAu,
    EuroCylinderHoleEu,
    OvalCylinderHole,
    PN6Hole,
    PD7Hole,
    RectangularHole,
    SquareHole,
    AnchorPoint
};

//# sourceMappingURL=v3.js.map